import "./common"; // must come first

/**
 * Initialize invertable select boxes and checkbox groups.
 */
$(() => {
  console.log("invertable.ts");

  // Handle invertable <select> elements
  $("select.invertable").each(function () {
    const $formGroup = $(this).closest(".form-group");
    const $label = $formGroup.find("label");

    // Avoid adding multiple buttons if already initialized
    if ($label.find(".invert").length === 0) {
      $label.append(' <a class="btn btn-default btn-xs invert"><i class="fa fa-exchange"></i></a>');
    }
  });

  $(document).on("click", ".invert", function (e) {
    const select = $(this).closest(".form-group").find("select")[0] as HTMLSelectElement;
    const tom = select.tomselect;
    if (!tom) return;

    e.preventDefault();
    e.stopPropagation();
    tom.close();
    tom.blur();

    const selectedValues = tom.getValue();
    const selected = Array.isArray(selectedValues)
      ? selectedValues
      : selectedValues ? [selectedValues] : [];

    const allValues = Array.from(select.options).map(option => option.value);
    const newValues = allValues.filter(value => !selected.includes(value));
    tom.setValue(newValues);
    tom.close();
  });

  // Handle invertable checkbox groups
  $(".form-group.check_boxes.invertable").each(function () {
    const $label = $(this).find("label.control-label");
    if ($label.find(".invertcb").length === 0) {
      $label.append(' <a class="btn btn-default btn-xs invertcb"><i class="fa fa-exchange"></i></a>');
    }
  });

  $(document).on("click", ".invertcb", function () {
    $(this)
      .closest(".form-group")
      .find('input[type="checkbox"]')
      .each(function () {
        const $checkbox = $(this);
        $checkbox.prop("checked", !$checkbox.prop("checked")).trigger("change");
      });
  });
});
